<template>
  <div class="content">
    <base-header class="pb-6 bg-gradient" type="">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 d-inline-block mb-0">
            Vertragsdaten erfassen
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">

      <div class="loader" v-if="this.loading"></div>

      <b-row class="card-wrapper">

        <b-col lg="12" id="main">
          <b-row class="card-wrapper">
            <b-col lg="12">

              <card>
                <!-- Card header -->

                <b-row align-v="center" slot="header">
                  <b-col cols="8">
                    <h3 slot="header" class="mb-0">
                      <i class="fa fa-user"></i>
                      Vertragsdaten erfassen
                    </h3>
                  </b-col>

                </b-row>

                <div class="Einstufung" v-if="currentAccount.hasRole('admin')">
                  Admin: Einstufung:
                  {{ offer.leveling_type }}: {{ offer.enstg[offer.leveling_type] }}
                  SF: {{ offer.customer_sf }}
                  SF2: {{ offer.customer_sf2 }}
                </div>

                <!-- Card body -->
                <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                  <form class="needs-validation" @submit.prevent="handleSubmit(mayWeCalc)">

                    <customer title="Kundendaten zum Vertrag" icon="fas fa-users"></customer>

                    <car title="Fahrzeugdaten zum Vertrag" icon="fas fa-car"></car>

                    <insurance title="Versicherungsdaten zum Vertrag" icon="fas fa-university"></insurance>

                    <holder title="Abweichender Halter" icon="fas fa-user" v-if="requires_holder()"></holder>
                    <button type="submit" class="btn btn-primary">Jetzt
            Speichern</button>

                  </form>
                </validation-observer>
              </card>

            </b-col>
          </b-row>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>
<script>



import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import BaseSlider from "@/components/BaseSlider";
import { Modal, BaseAlert } from "@/components";

import { Select, Option } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Customer from "../cscomponents/contract/Customer";
import Car from "../cscomponents/contract/Car";
import Insurance from "../cscomponents/contract/Insurance";
import Holder from "../cscomponents/contract/Holder";

import { mapGetters, mapState, mapMutations, mapActions } from "vuex";

export default {
  components: {
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    RouteBreadCrumb,
    BaseSlider,
    Modal,
    Customer,
    Insurance,
    Car,
    Holder,
  },
  data() {
    return {
      loading: false,
      edtload: false,
    };
  },
  props: {},
  methods: {

    mayWeCalc() {
      this.hsntsn = false;
      if(this.offer.is_company){
        this.offer.nationality = 'D';
      }
      console.log("VALIDITY edtload -> " + this.edtload);
      if (this.edtload) {
        return false
      }

      console.log("Validity: is_company -> " + this.offer.is_company);
      if (!this.offer.is_company) {
        console.log("Validity: dob -> " + this.offer.dob);
        if (!this.offer.dob) {
          return false;
        }
        console.log("Validity: firstname -> " + this.offer.firstname);
        if (!this.offer.firstname) {
          return false;
        }
        console.log("Validity: lastname -> " + this.offer.lastname);
        if (!this.offer.lastname) {
          return false;
        }
        console.log("Validity: title -> " + this.offer.title);
        if (!this.offer.title) {
          return false;
        }
      }
      else {
        console.log("Validity: company_name -> " + this.offer.company_name);
        if (!this.offer.company_name) {
          return false;
        }
      }

      console.log("Validity: street -> " + this.offer.street);
      if (!this.offer.street) {
        return false;
      }
      console.log("Validity: number -> " + this.offer.number);
      if (!this.offer.number) {
        return false;
      }
      console.log("Validity: nationality -> " + this.offer.nationality);
      if (!this.offer.nationality) {
        return false;
      }



      console.log("Validity: payment -> " + this.offer.kravag_payment_mode);
      if (this.offer.kravag_payment_mode == 'Lastschrift') {
        console.log("Validity: iban -> " + this.offer.iban);
        if (!this.offer.iban) {
          return false;
        }

        console.log("Validity: forgein_bank_owner -> " + this.offer.forgein_bank_owner);
        if (this.offer.forgein_bank_owner == 1) {

          console.log("Validity: forgein_bank_owner_firstname -> " + this.offer.forgein_bank_owner_firstname);
          if (!this.offer.forgein_bank_owner_firstname) {
            return false;
          }
          console.log("Validity: forgein_bank_owner_lastname -> " + this.offer.forgein_bank_owner_lastname);
          if (!this.offer.forgein_bank_owner_lastname) {
            return false;
          }
          console.log("Validity: forgein_bank_owner_street -> " + this.offer.forgein_bank_owner_street);
          if (!this.offer.forgein_bank_owner_street) {
            return false;
          }
          console.log("Validity: forgein_bank_owner_number -> " + this.offer.forgein_bank_owner_number);
          if (!this.offer.forgein_bank_owner_number) {
            return false;
          }
          console.log("Validity: forgein_bank_owner_zip -> " + this.offer.forgein_bank_owner_zip);
          if (!this.offer.forgein_bank_owner_zip) {
            return false;
          }
          console.log("Validity: forgein_bank_owner_city -> " + this.offer.forgein_bank_owner_city);
          if (!this.offer.forgein_bank_owner_city) {
            return false;
          }

        }

      }
      if (this.offer.kravag_payment_mode == '') {
        return false;
      }


      /*
      console.log("Validity: current_mileage -> " + this.offer.current_mileage);
      if (!this.offer.current_mileage) {
        return false;
      }
      */
      console.log("Validity: vin -> " + this.offer.vin);
      if (!this.offer.vin) {
        return false;
      }
      console.log("Validity: plate -> " + this.offer.plate);
      if (!this.offer.plate) {
        return false;
      }

      console.log("Validity: this.requires_insurance() -> " + this.requires_insurance());

      if (this.requires_insurance()) {
        console.log("Validity: insurance_id -> " + this.offer.insurance_id);
        if (!this.offer.insurance_id) {
          return false;
        }
        console.log("Validity: insurance_number -> " + this.offer.insurance_number);
        if (!this.offer.insurance_number) {
          return false;
        }
      }

      if (this.edtload === false) {
        this.submitToApi();
      }

    },


    // send via apollo
    submitToApi() {
      this.loading = true;
      this.$api
        .createContract(this.offer)
        .then((response) => {
          console.log(response);


          this.$router.push({
            name: 'Angebot anzeigen',
            params: { token: `${response.data.id}` },
          });

          //          offerId = response.data.id;
          //        this.$router.push({ path: `/offers/${offerId}` });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    requires_insurance() {
      console.log(this.offer.leveling_type);
      switch (this.offer.leveling_type) {

        case "V1":
          return true;
          break;
        case "V2":
          return true;
          break;
        case "D":
          return true;
          break;
        case "Z":
          return true;
          break;

          if (this.offer.selected_free_sfr) {
            return true;
          }
          return false;
      }
    },
    einstufungsgrund() {

    },
    requires_holder() {
      if (this.offer.holder_id == 'N') {
        return false;
      }
      return true;
    },
  },
  computed: {
    ...mapState({
      offer: (state) => state.offer,
    }),
    ...mapGetters({
      currentAccount: 'currentAccount'
    }),
    ...mapActions({
      fetchOffer: (state) => state.fetchOffer,
    }),
  },
  watch: {},
  mounted: function () {
    if (this.$route.params.token) {
      this.loading = true;
      this.$store.dispatch("fetchOffer", this.$route.params.token).then(() => {
        this.loading = false;
      });
      console.log("fetchedOFFFFER");
      console.log(this.offer);
      if(this.offer.is_company){
        this.offer.nationality = 'D';
      }
    }
  },
  created() { },
};
</script>
<style>

</style>